import { useRef, useEffect } from 'react';

import myDetails from '../assets/myDetails.json';

function TimeLine() {

    const timelineRef = useRef(null);
    useEffect(() => {
        const timeline = timelineRef.current;
        if (timeline) {
            timeline.scrollLeft = 0;
            const handleWheel = (event) => {
                event.preventDefault();
                timeline.scrollLeft += event.deltaY * 2;
            };

            timeline.addEventListener('wheel', handleWheel, { passive: false });

            return () => {
                timeline.removeEventListener('wheel', handleWheel);
            };
        }
    }, []);

    const scaleDist = 20
    const startYear = 2000;
    const endYear = startYear + myDetails?.life_events.length * scaleDist;
    const totalYears = endYear - startYear - 4;

    return (
        <div className="timeline-container" ref={timelineRef}>
            <div className="timeline">
                {Array.from({ length: totalYears }).map((_, index) => {
                    const eventIndex = Math.floor((index) / scaleDist);
                    const event = myDetails.life_events[eventIndex] && (index % scaleDist === 8) ? myDetails.life_events[eventIndex] : null;
                    return (
                        <div key={index} className="timeline-marker">
                            {event && (
                                <div className="event">
                                    {event.year !== 0 && (
                                        <span className="year">{event.year}</span>
                                    )}
                                </div>
                            )}
                            <div className={`line ${event ? 'long' : ''}`} />
                            {event && (
                                <div className="event">
                                    <span>
                                        <img className='tm-icon' src={event.icon} alt="event icon" />
                                    </span>
                                    <span className="description">{event.description}</span>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default TimeLine;